import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { importsByIdStatusReducers, importsByIdStatusWatchers } from './status';

export const importsByIdReducers = combineReducers({
	status: importsByIdStatusReducers
});

export const importsByIdWatchers = combineAllWatchers([
	importsByIdStatusWatchers
]);
